import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import 'bootstrap/dist/css/bootstrap.min.css';

import appSettings from "../../appSettings.json";
import './Skeleton.css';
import TicketList from '../TicketList/TicketList.js';
import TicketDetail from '../TicketDetail/TicketDetail.js';
import Header from '../../components/Header/Header.js';
import Footer from '../../components/Footer/Footer.js';
import useFetch from '../../shared/hooks/useFetch.js';
import getDefaultTicketFilters from '../../shared/utilities/getDefaultTicketFilters.js';
import isFilled from '../../shared/utilities/isFilled';
import { getCookie, deleteCookie } from '../../shared/utilities/cookies.js';

const Skeleton = (props) => {
    /* Inicializacion y props */
    const navigate = useNavigate();
    const view = props.view
    const[ticketsStateSummary, setTicketsStateSummary] = useState({pending: 0, process: 0, close: 0})
    

    /* URLs */
    const userDetail = `${appSettings.BASE_URL.default}/user/detail`;
    const upsertUser = `${appSettings.BASE_URL.default}/ticket/upsert-user`;
    const getUsers = `${appSettings.BASE_URL.default}/ticket/get-users?role=SAT`;

    /* LLamada API metodo detail */
    const[dataUser, setDataUser] = useState("");
    const[messageUser, setMessageUser] = useState("");
    const[successUser, setSuccessUser] = useState(false);
    
    const {serviceResponse : serviceResponseUser, error : errorUser, loading : loadingUser} = useFetch(userDetail, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getCookie("jwt")}, 'GET')

    useEffect(() => {
        if(!loadingUser){
            setDataUser(serviceResponseUser.data)
            setMessageUser(serviceResponseUser.message)
            setSuccessUser(serviceResponseUser.success)

            if(!serviceResponseUser.success) logout()
        }
    }, [loadingUser, serviceResponseUser, errorUser])

    const[formikValues, setFormikValues] = useState(getDefaultTicketFilters())

    useEffect(() => {
        if(isFilled(dataUser?.installation)){
            setFormikValues(getDefaultTicketFilters(dataUser))
        }
    }, [dataUser])

    /* LLamada API metodo upsertUser */
    const[dataUpsertUser, setDataUpsertUser] = useState("");
    const[messageUpsertUser, setMessageUpsertUser] = useState("");
    const[successUpsertUser, setSuccessUpsertUser] = useState(false);

    const {serviceResponse : serviceResponseUpsUser, error : errorUpsUser, loading : loadingUpsUser} = useFetch(upsertUser, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getCookie("jwt")}, 'POST', "empty")

    useEffect(() => {
        if(!loadingUpsUser){
            setDataUpsertUser(serviceResponseUpsUser.data)
            setMessageUpsertUser(serviceResponseUpsUser.message)
            setSuccessUpsertUser(serviceResponseUpsUser.success)

            if(!serviceResponseUpsUser.success) logout()
        }
    }, [loadingUpsUser, serviceResponseUpsUser, errorUpsUser])

    /* LLamada API metodo get-usersSAT */
    const[dataGetUsers, setDataGetUsers] = useState("");
    const[messageGetUsers, setMessageGetUsers] = useState("");
    const[successGetUsers, setSuccessGetUsers] = useState(false);
    
    const {serviceResponse : serviceResponseGetUsers, error : errorGetUsers, loading : loadingGetUsers} = useFetch(getUsers, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getCookie("jwt")}, 'GET')

    useEffect(() => {
        if(!loadingGetUsers){
            setDataGetUsers(serviceResponseGetUsers.data)
            setMessageGetUsers(serviceResponseGetUsers.message)
            setSuccessGetUsers(serviceResponseGetUsers.success)
        }
    }, [loadingGetUsers, serviceResponseGetUsers, errorGetUsers])

    /* Cerrar Sesion */
    const logout = () => {
        deleteCookie("jwt")
        navigate('/');
    }

    const resetTicketFilters = () => {
        setFormikValues(getDefaultTicketFilters(dataUser))
    }

    /* Renderizar Vista dependiendo de los params */
    const renderView = () => {
        switch(view){
            case 1: return <TicketList user = {dataUser} usersSAT = {dataGetUsers} setTicketsStateSummary = {setTicketsStateSummary} formikValues = {formikValues} setFormikValues = {setFormikValues} resetTicketFilters = {resetTicketFilters}/>
            case 2: return <TicketDetail user = {dataUser} usersSAT = {dataGetUsers} setTicketsStateSummary = {setTicketsStateSummary}/>
            default: return <div>Ha ocurrido un error al renderizar la vista con el parametro view = {view}</div>
        }
    }

    return (
        <div>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successUser && !loadingUser} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al obtener el usuario. Mensaje API: " + messageUser}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successUpsertUser && !loadingUpsUser} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error insertar/actualizar usuario en tickets. Mensaje API: " + messageUpsertUser}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successGetUsers && !loadingGetUsers} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al obtener los usuarios SAT. Mensaje API: " + messageGetUsers}
                </Alert>
            </Snackbar>
            {isFilled(dataUser.installation) && !loadingUser
            ?
                <div style={{margin: "15px 20px"}}>
                    <Header user = {dataUser} logout = {logout} ticketsStateSummary = {ticketsStateSummary} resetTicketFilters = {resetTicketFilters}/>
                    <hr size = "8px"/>
                    {renderView()}
                    <hr size = "8px"/>
                    <Footer />
                </div>
            :
                <div className="d-flex justify-content-center text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            }
        </div>
    );
}

export default Skeleton;
